<panel width="400">
    <h1>{{ 'company.accounting-plans.change-end-date.header' | translate }}</h1>

    <section>
        <tooltip [text]="'company.accounting-plans.enddate-restricted-by-annual-date' | translate:{ date: productPlan?.restrictEndDate }" [disabled]="!productPlan?.restrictEndDate">
            <date-input [label]="'company.accounting-plans.edit-end-date' | translate" [(value)]="newEndDate" (valueChange)="updateLedgerPosts($event)" [required]="true" [minDate]="minEndDate" [filterDates]="subscriptionEndDatesFilter" />
        </tooltip>
    </section>

    <list-view [selectable]="false" emptyLabel="">
        @if (isMismatchOfAcvAndAnnualRenewalValue && accountingPlan && newEndDate != accountingPlan.endDate) {
            <list-item warning statusIcon="exclamation-triangle">
                {{ 'company.product-plans.current-annual-contract-value' | translate: {'ACV' : (annualContractValue | currency), 'AnnualValueForRenewal': (annualValueForRenewal | currency)} }}
            </list-item>
        }
    </list-view>

    <section>
        <button ghost (click)="cancel()" [ignoreValidation]="true">{{ 'general.cancel' | translate }}</button>
        <button (click)="changeEndDate(false)">{{ (isMismatchOfAcvAndAnnualRenewalValue && accountingPlan && newEndDate != accountingPlan.endDate ? 'company.accounting-plans.save-enddate-but-not-annual-value' : 'general.save') | translate }}</button>
        @if (isMismatchOfAcvAndAnnualRenewalValue && accountingPlan && newEndDate != accountingPlan.endDate) {
            <button (click)="changeEndDate(true)">{{ 'company.accounting-plans.save-enddate-and-annual-value' | translate }}</button>
        }
    </section>
</panel>

@if (productPlan && accountingPlan) {
    <panel width="600">
        <h1>{{ 'ledger-posts.header' | translate }}</h1>
        <ledger-posts #ledgerPosts [productPlans]="[productPlan]" [displayProductName]="false" [accountingPlan]="accountingPlan" [allowChangingTotalValue]="true" />
    </panel>
}
